(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dbh-pdp-pairs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dbh-pairs')) {
    class DbhPairs extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-loaded')) {
          if (!this.querySelector('.dbh-pairs__row')) this.setAttribute('data-empty', '');
          return;
        }
        if (!('IntersectionObserver' in window)) {
          this.load();
          return;
        }
        const observer = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            observer.disconnect();
            this.load();
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        observer.observe(this);
      }

      async load() {
        try {
          const response = await fetch(this.dataset.url);
          if (!response.ok) throw new Error(String(response.status));
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('dbh-pairs');
          if (fresh && fresh.querySelector('.dbh-pairs__row')) {
            this.innerHTML = fresh.innerHTML;
            this.setAttribute('data-loaded', '');
          } else {
            this.setAttribute('data-empty', '');
          }
        } catch (error) {
          this.setAttribute('data-empty', '');
        }
      }
    }
    customElements.define('dbh-pairs', DbhPairs);
  }

  } catch(e) { console.error(e); }
})();
})();
